// material-ui
import {
  Typography,
  Box,
  Avatar,
  Icon,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  InputAdornment,
  IconButton,
  TextField,
  DialogActions
} from "@mui/material";

// assets
import { Fragment, useEffect, useState } from "react";
import {
  type IntranetPortal_Occasions_Dtos_AllWorkAnniversaryMessageListForTodayDto,
  type IntranetPortal_Occasions_Dtos_EmployeeListForWorkAnniversaryDto,
  type IntranetPortal_Occasions_Dtos_MyWorkAnniversaryTodayDto,
  OccasionService,
  type IntranetPortal_Occasions_Dtos_MessageListForMyWorkAnniversaryDto
} from "../../../services/intranet-portal-services";
import useIntranetPortalCoreApi from "../../../hooks/useIntranetPortalAdminApi";
import EmojiPicker from "emoji-picker-react";
import EmojiEmotionsOutlinedIcon from "@mui/icons-material/EmojiEmotionsOutlined";
import Confetti from "react-confetti";

// import  RedeemIcon  from '@material-ui/icons';
import { MdOutlineCake } from "react-icons/md";
import { toast } from "react-toastify";
import { FiMessageSquare } from "react-icons/fi";
import { BirthCard } from ".";
import { BiMessageSquareCheck } from "react-icons/bi";
import CustomButton from "../../../ui-component/CustomUiComponent/Button";
import CakeOutlinedIcon from "@mui/icons-material/CakeOutlined";
import { SkeletonLoading } from "./BirthdayCeleb";
import CustomAvatar from "../../../ui-component/CustomUiComponent/Avatar";
import dayjs from "dayjs";

const Anniversary = (): React.ReactElement => {
  const { handleRequest, isLoading } = useIntranetPortalCoreApi();

  const [allAnniversaryToday, setAllAnniversaryToday] =
    useState<IntranetPortal_Occasions_Dtos_EmployeeListForWorkAnniversaryDto[]>();
  const [myAnniversary, setMyAnniversary] = useState<
    IntranetPortal_Occasions_Dtos_MyWorkAnniversaryTodayDto[]
  >([]);
  const [messagesToMe, setMessagesToMe] =
    useState<IntranetPortal_Occasions_Dtos_MessageListForMyWorkAnniversaryDto[]>();
  const [messageSentByMe, setMessageSentByMe] =
    useState<IntranetPortal_Occasions_Dtos_AllWorkAnniversaryMessageListForTodayDto[]>();
  const [wishMessage, setWishMessage] = useState("");
  const [isOpenSentBox, setIsOpenSentBox] = useState(false);
  const [currentOccasionId, setCurrentOccasionId] = useState("");
  const [isOpenWishRecieveBox, setIsOpenWishRecieveBox] = useState(false);
  const [isOpenViewBox, setIsOpenViewBox] = useState(false);
  const [showPicker, setShowPicker] = useState(false);
  const [showConfetti, setShowConfetti] = useState(false);
  const [isFirstLogin, setIsFirstLogin] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  // GET ALL EMPLOYEE ANNIVERSARY LIST AND SEND MESSAGED BY ME
  const getAllEmployeeWithAnniversaryAndSentMessageByMe = async (): Promise<void> => {
    const response = await handleRequest(() =>
      OccasionService.getCoreApiApiAppOccasionEmployeeListForWorkAnniversaryToday()
    );
    if (response != null) {
      setAllAnniversaryToday(response);
    }

    const sentMessageResp = await handleRequest(() =>
      OccasionService.getCoreApiApiAppOccasionWorkAnniversaryMessageListSentByMeToday()
    );
    if (sentMessageResp != null) {
      setMessageSentByMe(sentMessageResp);
    }
  };

  // GET TODAY MY ANNIVERSARY AND WISH RECEIVED MESSAGE
  const getMyAnniversaryAndgetMyWishRecievedMessage = async (): Promise<void> => {
    const response = await handleRequest(() =>
      OccasionService.getCoreApiApiAppOccasionMyWorkAnniversaryToday()
    );
    if (response !== null && response !== undefined) {
      setMyAnniversary([response]);
    }
    if (response?.occasionId != null) {
      const wishedMessageData = await handleRequest(() =>
        OccasionService.getCoreApiApiAppOccasionMessageListForMyWorkAnniversary(
          response?.occasionId
        )
      );
      setMessagesToMe(wishedMessageData ?? []);
    }
  };

  // const pollForData = async () => {
  //   const response = await handleRequest(() =>
  //     OccasionService.getCoreApiApiAppOccasionMyWorkAnniversaryToday()
  //   );
  //   setMyAnniversary(response?.occasionId);

  //   while (response) {
  //     await getMyAnniversaryAndgetMyWishRecievedMessage();
  //     await new Promise((resolve) => setTimeout(resolve, 5000)); // Wait for 5 seconds before making the next request
  //   }
  // };

  // HANDLE CHANGE WISH MESSAGE
  const handleChangeWishMessage = (e: any): void => {
    const value = e.target.value.slice(0, 280);
    if (value.length < 280) {
      setErrorMessage("");
      setWishMessage(value);
    } else {
      setErrorMessage("maximum length reached");
    }
  };

  // HANDLE SEND MESSAGE BOX CLOSE
  const closeMessageBox = (): void => {
    setCurrentOccasionId("");
    setErrorMessage("");

    setIsOpenSentBox(false);
  };

  // HANDLE SEND MESSAGE BOX OPEN
  const openMessageBox = (occasionId: string): void => {
    setWishMessage("");
    setErrorMessage("");
    setIsOpenSentBox(true);
    setCurrentOccasionId(occasionId);
    setShowPicker(false);
  };

  // HANDLE SUBMIT WISH MESSAGE
  const sendWishMessage = async (
    occasionId: string,
    fullName: string,
    wishedMessage: string
  ): Promise<void> => {
    try {
      if (wishMessage.length === 0) {
        setErrorMessage("Please, write a message");
      } else {
        closeMessageBox();
        const payload = { occasionId, wishedMessage };
        const response = await handleRequest(() =>
          OccasionService.postCoreApiApiAppOccasionWishWorkAnniversary(payload)
        );
        if (response != null) {
          toast.success(`Send to ${fullName}`, {
            position: "top-right",
            autoClose: 1500,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light"
          });
          await getAllEmployeeWithAnniversaryAndSentMessageByMe();
        }
      }
    } catch (error) {}
  };

  useEffect(() => {
    void getAllEmployeeWithAnniversaryAndSentMessageByMe();
    void getMyAnniversaryAndgetMyWishRecievedMessage();
  }, []);

  // HANDLE RECIEVE MESSAGE BOX OPEN
  const openRecievedMessageBox = (): void => {
    setIsOpenWishRecieveBox(true);
  };

  // HANDLE RECIEVE MESSAGE BOX CLOSE
  const closeRecievedMessageBox = (): void => {
    setIsOpenWishRecieveBox(false);
  };

  // OPEN VIEW SENT MESSAGE
  const openViewSendWish = (occasionId: string): void => {
    setCurrentOccasionId(occasionId);
    setIsOpenViewBox(true);
  };

  // CLOSE VIEW SENT MESSAGE
  const closeViewSendWish = (): void => {
    setCurrentOccasionId("");
    setIsOpenViewBox(false);
  };
  const handleConfetti = (): void => {
    setShowConfetti(true);
    setTimeout(() => {
      setShowConfetti(false);
    }, 6000);
  };

  // SORTING ALL ANNIVERSARY TODAY

  const sortALlAnniversaryData = (firstItem: any, secondItem: any): number => {
    const hasMessageInFirst = (messageSentByMe ?? []).some(
      (message) => message?.occasionId === firstItem?.occasionId
    );
    const hasMessageInSecond = (messageSentByMe ?? []).some(
      (message) => message?.occasionId === secondItem?.occasionId
    );

    if (hasMessageInFirst && !hasMessageInSecond) {
      return 1; // Move firstItem to the bottom
    } else if (!hasMessageInFirst && hasMessageInSecond) {
      return -1; // Move secondItem to the bottom
    } else {
      return firstItem?.fullName?.localeCompare(secondItem?.fullName) || 0; // Sort alphabetically by fullName
    }
  };

  const onEmojiClick = (emojiObject: { emoji: string }): void => {
    if (wishMessage.length < 280) {
      setWishMessage(wishMessage + emojiObject.emoji);
    } else {
      setErrorMessage("maximum length reached");
    }
  };

  const handlePopupClose = (): void => {
    setIsFirstLogin(false);
  };

  // handle once anniversary popup
  const loginStatus = localStorage.getItem("anniversaryLogin");
  const todayDate = JSON.stringify(dayjs().format("MM-DD-YYYY"));
  if (myAnniversary?.length > 0) {
    if (!loginStatus) {
      localStorage.setItem("anniversaryLogin", todayDate);
      setIsFirstLogin(true);
    }
  } else {
    !!loginStatus && loginStatus != todayDate && localStorage.removeItem("anniversaryLogin");
  }

  if (isLoading) {
    return <SkeletonLoading />;
  }

  const windowHeight = window.innerHeight ?? 300;
  const windowWidth = window.innerWidth ?? 300;

  return (
    <>
      {/* Login Anniversary Celebration PopUp */}
      {isFirstLogin
        ? myAnniversary?.length > 0 && (
            <Dialog
              PaperProps={{
                style: {
                  overflow: "initial"
                }
              }}
              style={{ backdropFilter: "blur(2px)" }}
              open={isFirstLogin}
              onClose={handlePopupClose}
            >
              <Confetti
                height={windowHeight}
                width={windowWidth}
                numberOfPieces={200}
                style={{ position: "fixed", top: 0, left: 0 }}
              />
              <BirthCard className="birthCard cardView popUpCard" style={{ marginTop: 0 }}>
                <Avatar
                  className="avatar"
                  src={`${myAnniversary[0]?.profilePictureUrl as string}`}
                  alt=""
                />
                <Box className="birthCard_content">
                  <Box sx={{ flex: 1 }}>
                    <Box className="user">
                      <Box component="span">{myAnniversary[0]?.fullName}</Box>
                    </Box>
                    <Box className="designation">{myAnniversary[0]?.designationName}</Box>

                    <Box
                      sx={{
                        color: "#D42C2C",
                        fontWeight: "500",
                        mt: 2
                      }}
                    >
                      <Box
                        className="typing"
                        sx={{
                          fontSize: "16px",
                          color: "#313131",
                          lineHeight: "24px"
                        }}
                      >
                        Hello {myAnniversary[0]?.fullName}.{" "}
                        <Box
                          component="span"
                          style={{
                            fontSize: "24px",
                            color: "#D42C2C",
                            fontFamily: "cursive"
                          }}
                        >
                          Congratulations on your work anniversary!{" "}
                        </Box>
                        Thank you for your generosity, your constant enthusiasm, and for all the
                        unnoticed support over the years.
                      </Box>
                    </Box>
                    <Box sx={{ width: "100%", textAlign: "end" }}>
                      <Box component="span" className="date">
                        ~ HR
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </BirthCard>
            </Dialog>
          )
        : ""}

      {/* Anniversdary And Received Messages */}
      {myAnniversary?.length > 0 ? (
        <BirthCard className="birthCard" style={{ marginTop: 0, marginBottom: "1rem" }}>
          <Avatar
            className="avatar"
            src={`${myAnniversary[0]?.profilePictureUrl as string}`}
            alt=""
          />
          <Box className="birthCard_content">
            <Box>
              <Box className="user " style={{ flexDirection: "column" }}>
                <Box
                  sx={{
                    fontWeight: 400,
                    color: "#d82d2b",
                    mr: 1,
                    fontSize: "16px"
                  }}
                >
                  Congrats on work anniversary!
                </Box>
                {myAnniversary[0]?.fullName}
              </Box>
              {messagesToMe != null && messagesToMe?.length > 0 ? (
                <Button
                  onClick={() => {
                    openRecievedMessageBox();
                    handleConfetti();
                  }}
                  sx={{
                    ml: -1,
                    display: "flex",
                    gap: 1,
                    alignItems: "center",
                    color: "#D42C2C",
                    fontWeight: "500"
                  }}
                >
                  <FiMessageSquare />
                  <Box sx={{ fontSize: "12px" }}>
                    You received {(messagesToMe ?? []).length}{" "}
                    {(messagesToMe?.length ?? 0) > 1 ? "greetings" : "greeting"}
                  </Box>
                </Button>
              ) : null}
              {messagesToMe != null && messagesToMe?.length > 0 ? (
                <Dialog
                  PaperProps={{
                    style: {
                      maxHeight: "550px",
                      overflowY: "auto",
                      width: "100%"
                    }
                  }}
                  open={isOpenWishRecieveBox}
                  onClose={closeRecievedMessageBox}
                >
                  {showConfetti && <Confetti height={170} width={550} numberOfPieces={40} />}
                  <DialogTitle>Received Messages Inbox</DialogTitle>
                  <DialogContent sx={{ width: "100%" }}>
                    {/* Display the rest of the recieved msg items */}
                    {messagesToMe?.map((item: any) => (
                      <BirthCard
                        className="birthCard"
                        style={{ marginTop: 0, marginBottom: "5px" }}
                        key={item.wishedById}
                      >
                        {showConfetti && (
                          <Confetti height={90} width={550} opacity={0.9} numberOfPieces={40} />
                        )}
                        <Avatar className="avatar" src={item?.wishedByProfilePictureUrl} alt="" />
                        <Box className="birthCard_content">
                          <Box sx={{ flex: 1 }}>
                            <Box className="user">{item?.wishedByFullName}</Box>
                            <Box className="designation">
                              {`${item?.wishedByDesignationName as string}`}
                            </Box>
                            <Box
                              sx={{
                                color: "#D42C2C",
                                fontWeight: "500",
                                mt: 1
                              }}
                            >
                              <Box sx={{ fontSize: "16px" }}>{item.wishedMessage}</Box>
                            </Box>
                            <Box sx={{ width: "100%", textAlign: "end" }}>
                              <Box component="span" className="date">
                                ~ {dayjs(item.wishedOn).format("HH:mm")}
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      </BirthCard>
                    ))}
                  </DialogContent>
                </Dialog>
              ) : (
                ""
              )}
            </Box>
          </Box>
        </BirthCard>
      ) : (
        ""
      )}
      {/* All Anniversary Today  */}
      <Box>
        <Typography
          variant="h6"
          sx={{
            fontWeight: "400",
            mb: "0.5rem",
            display: "flex",
            lineHeight: "32px"
          }}
        >
          <Icon color="primary" sx={{ mr: "8px" }}>
            <MdOutlineCake size="2rem" />
          </Icon>
          Work Anniversary Today
        </Typography>
        {allAnniversaryToday != null && allAnniversaryToday?.length >= 1 ? (
          <>
            {allAnniversaryToday
              .sort(
                (
                  a: IntranetPortal_Occasions_Dtos_EmployeeListForWorkAnniversaryDto,
                  b: IntranetPortal_Occasions_Dtos_EmployeeListForWorkAnniversaryDto
                ): number => {
                  return sortALlAnniversaryData(a, b);
                }
              )
              .map((item: any) => (
                <BirthCard className="birthCard" key={item.occasionId}>
                  <CustomAvatar className="avatar" src={`${item.profilePictureUrl as string}`} />
                  <Box className="birthCard_content">
                    <Box>
                      <Box className="user">{item.fullName}</Box>
                      <Box className="designation">{`${item.designationName as string}`}</Box>
                      {/* view message sent by me */}
                      {(messageSentByMe ?? []).find(
                        (message: any) => message.occasionId === item.occasionId
                      ) != null ? (
                        <Button
                          onClick={() => {
                            openViewSendWish(item.occasionId);
                          }}
                          sx={{
                            display: "flex",
                            gap: 1,
                            alignItems: "center",
                            color: "#D42C2C",
                            fontWeight: "500"
                          }}
                        >
                          <FiMessageSquare />
                          <Box sx={{ fontSize: "12px" }}>View wish</Box>
                        </Button>
                      ) : (
                        ""
                      )}
                    </Box>
                    {(messageSentByMe ?? []).find(
                      (message: any) => message.occasionId === item.occasionId
                    ) != null ? (
                      <Box className="notify">
                        <BiMessageSquareCheck /> Wish sent
                      </Box>
                    ) : (
                      <CustomButton
                        variant="contained"
                        color="error"
                        label={"Send Wish"}
                        sx={{ mt: 0, textWrap: "noWrap" }}
                        onClick={() => {
                          openMessageBox(item.occasionId);
                        }}
                      />
                    )}
                  </Box>
                </BirthCard>
              ))}
          </>
        ) : (
          <Box className="noDataBox">
            <CakeOutlinedIcon />
            <Box component="span">No work anniversaries today, party confetti in hibernation!</Box>
          </Box>
        )}
      </Box>

      {/* message by me and send Message Popup */}
      <>
        {allAnniversaryToday != null && allAnniversaryToday?.length >= 1 ? (
          <>
            {allAnniversaryToday?.map((item: any) => (
              <Fragment key={item.occasionId}>
                {/* dialog box  message sent by me */}
                {currentOccasionId === item.occasionId &&
                  (messageSentByMe ?? []).map((message: any, index) => {
                    if (message.occasionId === item.occasionId) {
                      return (
                        <Dialog
                          key={item.occasionId}
                          PaperProps={{
                            style: {
                              overflow: "initial"
                            }
                          }}
                          open={isOpenViewBox}
                          onClose={closeViewSendWish}
                        >
                          {/* Display the rest of the data items */}

                          <>
                            <BirthCard className="birthCard cardView" style={{ marginTop: 0 }}>
                              <Avatar
                                className="avatar"
                                src={message.wishedToprofilePictureUrl}
                                alt=""
                              />
                              <Box className="birthCard_content">
                                <Box sx={{ flex: 1 }}>
                                  <Box className="user">{message.wishedToFullName}</Box>
                                  <Box className="designation">
                                    {message.wishedToDesignationName}
                                  </Box>
                                  <Box
                                    sx={{
                                      color: "#D42C2C",
                                      fontWeight: "500",
                                      mt: 2
                                    }}
                                  >
                                    <Box sx={{ fontSize: "16px" }}>{message.wishedMessage}</Box>
                                  </Box>
                                  <Box sx={{ width: "100%", textAlign: "end" }}>
                                    <Box component="span" className="date">
                                      ~ {dayjs(message.wishedOn).format("HH:mm")}
                                    </Box>
                                  </Box>
                                </Box>
                              </Box>
                            </BirthCard>
                          </>
                        </Dialog>
                        // </Grid>
                      );
                    } else {
                      return null;
                    }
                  })}

                {/* Dialog box send message box */}
                {currentOccasionId === item.occasionId && (
                  <Dialog
                    PaperProps={{
                      style: {
                        minHeight: "300px",
                        width: "100%"
                      }
                    }}
                    open={isOpenSentBox}
                    onClose={closeMessageBox}
                  >
                    <DialogContent sx={{ width: "100%" }}>
                      <BirthCard className="birthCard" style={{ marginTop: 0 }}>
                        <Avatar
                          className="avatar"
                          src={`${item.profilePictureUrl as string}`}
                          alt=""
                        />
                        <Box className="birthCard_content">
                          <Box>
                            <Box className="user">{item.fullName}</Box>
                            <Box className="designation">{`${
                              item.departmentName as string
                            }, ${item.designationName as string}`}</Box>
                          </Box>
                        </Box>
                      </BirthCard>

                      <TextField
                        autoFocus
                        multiline
                        margin="dense"
                        id="name"
                        value={wishMessage}
                        label={`Extend warm wishes to ${
                          item.fullName.match(/^\S+/)?.[0] as string
                        } on his work anniversary`}
                        fullWidth
                        variant="standard"
                        onChange={(e) => {
                          handleChangeWishMessage(e);
                        }}
                        helperText={errorMessage.length > 0 && errorMessage}
                        FormHelperTextProps={{
                          sx: {
                            fontSize: "12px",
                            color: "red"
                          }
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                sx={{ color: "#D42C2C" }}
                                size="large"
                                onClick={() => {
                                  setShowPicker(!showPicker);
                                }}
                              >
                                <EmojiEmotionsOutlinedIcon />
                              </IconButton>{" "}
                            </InputAdornment>
                          )
                        }}
                      />
                      {showPicker && (
                        <Box display="flex" justifyContent="center" alignItems="center">
                          <EmojiPicker
                            skinTonesDisabled={true}
                            lazyLoadEmojis={true}
                            width="100%"
                            onEmojiClick={onEmojiClick}
                          />
                        </Box>
                      )}
                    </DialogContent>

                    <DialogActions>
                      <Button variant="outlined" onClick={closeMessageBox}>
                        Cancel
                      </Button>
                      <Button
                        variant="contained"
                        color="error"
                        onClick={() => {
                          void sendWishMessage(item.occasionId, item.fullName, wishMessage);
                        }}
                      >
                        Send
                      </Button>
                    </DialogActions>
                  </Dialog>
                )}
              </Fragment>
            ))}
          </>
        ) : (
          ""
        )}
      </>
    </>
  );
};

export default Anniversary;
